import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DataService } from '../../../../Services/DataSharingService';
import { Subscription } from 'rxjs/Subscription';
import { HeaderService } from '../../../../Services/HeaderService';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-hr-divider',
  templateUrl: './hr-divider.component.html',
  styleUrls: ['./hr-divider.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class HrDividerComponent implements OnInit {

	@ViewChild('container', { read: ElementRef }) container: ElementRef;

	private subscription: Subscription[] = [];
	public data: string = '';
	public showCode = '';
	constructor(private _dataService: DataService, private cdRef: ChangeDetectorRef, private _headerService: HeaderService, private _titleService: Title) {
		_titleService.setTitle('Divider');
		_dataService.GetCode().subscribe(data => {
			this.data = data;
		})
		_dataService.showCode.subscribe(value => {
			this.showCode = value;
		})
	}
	// ngOnInit() {
	// 	this.subscription.push(this._dataService.GetCode().subscribe(code => {
	// 		this.data = code;
	// 		this.cdRef.detectChanges();
	// 	}));

	// 	this.cdRef.detectChanges();
	// 	this._dataService.SetCode(this.container.nativeElement.innerHTML);
	// }
	ngOnInit() {
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}
	ngOnDestroy(): void {
		this.subscription.map(subscription => {
			subscription.unsubscribe();
		})
	}
	ShowCode(event) {
		this.data = this.container.nativeElement.innerHTML;
		if(this.showCode == 'hr-divider'){
			this._dataService.setState('');
		}else{
			this._dataService.setState('hr-divider');
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/features/divider/hr-divider/hr-divider.component.ts